<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Evento" />
  <menuLateral />

  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
                <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
                <b-spinner class="ml-2" variant="danger"></b-spinner>
              </div>
              <form class="forms-sample">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="inputEvento" class="required">Evento</label>
                    <input type="text" maxlength="255" v-model="formulario.f_summary" :disabled="desabilitaCampo" class="form-control" id="inputEvento">
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_summary}}</div>
                  </div>
                  <div class="form-group col-md-12 col-lg-12 col-xl-12">
                    <label for="inputLocal">Local</label>
                    <input type="text" maxlength="255" v-model="formulario.f_location" :disabled="desabilitaCampo" class="form-control" id="inputLocal">
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_location}}</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <label for="inputDataInicio" class="required">Início</label>
                    <Datefield v-model="formulario.f_dtstart" :classField="'form-control'" :disabled="desabilitaCampo" id="inputDataInicio"/>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_dtstart']}}</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-6 col-lg-6 col-xl-2">
                    <Timefield v-model="formulario.f_hour_begin" @input="preencherDataHoraTerminoCalculado" :classField="'form-control altura-botaoHora-cadastro'" :disabled="desabilitaCampo" />
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_hour_begin']}}</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <label for="inputDataTermino" class="required">Término</label>
                    <Datefield v-model="formulario.f_dtend" ref="dateFieldEnd" :classField="'form-control'" :disabled="desabilitaCampo" id="inputDataTermino"/>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_dtend']}}</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-6 col-lg-6 col-xl-2">
                    <Timefield v-model="formulario.f_hour_end" :classField="'form-control altura-botaoHora-cadastro'" :disabled="desabilitaCampo" />
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_hour_end']}}</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-6">
                    <label for="inputRecorrencia">Recorrência</label>
                    <b-form-select v-model="formulario.recurrence" :options="recorrenciaEventoOptions" :disabled="desabilitaCampo" class="form-control comboFonteDefault" id="inputRecorrencia"></b-form-select>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.recurrence}}</div>
                  </div>
                  <div v-show="apresentarTerminoOcorrencia" class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-6">
                    <label for="inputTerminoRecorrencia" class="required">Término da recorrência</label>
                    <Datefield v-model="formulario.recurrence_final_date" :classField="'form-control'" :disabled="desabilitaCampo" id="inputTerminoRecorrencia"/>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['recurrence_final_date']}}</div>
                  </div>
                  <div class="form-group col-md-12 col-lg-12 col-xl-12">
                    <label for="inputDescricao">Descrição</label>
                    <textarea type="textarea" rows="4" v-model="formulario.f_description" :disabled="desabilitaCampo" class="form-control" id="inputDescricao"></textarea>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_description}}</div>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="inputOrganizador" class="">Organizador</label>
                    <input type="text" v-model="formulario.organizer" :disabled="true" class="form-control" id="inputOrganizador">
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.organizer}}</div>
                  </div>
                  <div class="agrupamento col-xl-12">
                    <div class="form-row col-xl-12">
                      <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <label class="mt-2" for="inputUnidades">Unidades/Equipes</label>
                          <v-select multiple
                                    label="f_name"
                                    class="style-chooser"
                                    v-model="unidadesSelecionadas"
                                    :options="comboUnidadesFiltradas"
                                    :disabled="desabilitaCampo"
                                    :filterable="false"
                                    :selectable="option => option.f_users_count > 0"
                                    @search="eventoDigitarBuscaPorUnidade"
                                    placeholder="Selecione uma ou mais unidades para adicionar todos os seus participantes">
                            <template #option="option">
                              <div>
                                <span>{{ option.f_name }}</span>
                                <span v-if="option.f_users_count > 0"
                                      class="badge badge-primary ml-2">
                                  {{ option.f_users_count }}
                                </span>
                                <span v-else
                                      class="badge badge-warning ml-2">
                                  vazia
                                </span>
                              </div>
                            </template>
                            <template #selected-option="option">
                              <div class="d-flex align-items-center">
                                <span>{{ option.f_name }}</span>
                                <span v-if="option.f_users_count > 0"
                                      class="badge badge-primary ml-2">
                                  {{ option.f_users_count }}
                                </span>
                              </div>
                            </template>

                            <template #no-options>
                              <em>Nenhuma unidade encontrada.</em>
                            </template>
                          </v-select>
                        <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_units.*']}}</div>
                      </div>
                    </div>

                    <div class="form-row col-xl-12">
                      <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-11">
                        <label class="mt-2" for="inputCapas">Participantes</label>
                        <v-select taggable
                          :get-option-label="customizarLabel"
                          label="f_name"
                          class="style-chooser"
                          v-model="participanteSelecionado"
                          @search="eventoDigitarBuscaPorParticipante"
                          :options="comboParticipantesDisponiveis"
                          :disabled="desabilitaCampo"
                          :filterable="false">
                          <template v-slot:no-options>
                            <em>Nenhum registro encontrado.</em>
                          </template>
                        </v-select>
                        <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['participanteSelecionado']}}</div>
                        <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_participants.*.']}}</div>
                        <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_participants.*.f_email']}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-1">
                        <b-button class="botoes" style="margin-top: 2.6rem;" variant="outline-primary btn-sm" @click="adicionarNaLista()" :disabled="desabilitaCampo">Adicionar</b-button>
                      </div>
                      <div class="col-12 d-flex justify-content-end mb-2">
                        <button
                          v-if="participantesParaExcluir.length > 0"
                          class="btn btn-outline-danger d-flex align-items-center"
                          style="font-size: 0.85rem;"
                          @click.prevent="abrirModalParticipantesMarcadosParaExclusao"
                          title="Ver participantes já cadastrados que serão removidos ao salvar."
                        >
                          <i class="fas fa-user mr-2"></i>
                          Gerir exclusões

                          <span class="badge badge-danger ml-2">
                            {{ participantesParaExcluir.length }}
                          </span>
                        </button>
                      </div>

                      <default-table
                        :items="listaParticipantes"
                        :fields="fieldsParticipantes"
                        :busy="desabilitaCampo"
                        :tbody-tr-class="tabelaSemRegistros"
                        :sort-by="componenteOrdenacao.campo"
                        :sort-direction="componenteOrdenacao.sentido"
                        :no-local-sorting="!desabilitaNavegacaoParticipantes"
                        @sortChanged="onSortChanged">
                        <template #empty>
                          <em>Nenhum registro encontrado.</em>
                        </template>
                        <template #cell(f_name)="row">
                            <i class="fas fa-address-book"></i> {{ row.item.f_name }}
                            <div class="avisoDanger text-left mt-1">{{ row.item.erros }}</div>
                        </template>
                        <template #cell(f_email)="row">
                          <i class="fas fa-address-book"></i> {{ row.item.f_email }}
                        </template>
                        <template #cell(opcoes)="row">
                          <div v-if="row.item.f_id" class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                                type="checkbox"
                                class="custom-control-input switch-invertido"
                                :id="`switch_excluirParticipante_${row.item.f_id ?? 'novo_' + row.index}`"
                                v-model="row.item.selecionadoParaExclusao"
                                :disabled="desabilitaCampo"
                                @change="marcarParticipanteParaExclusao(row.item)">
                            <label
                                class="custom-control-label"
                                :for="`switch_excluirParticipante_${row.item.f_id ?? 'novo_' + row.index}`">
                              Excluir participante
                            </label>
                          </div>
                          <div v-else class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                                type="checkbox"
                                class="custom-control-input switch-invertido"
                                :id="`switch_excluirParticipante_${row.item.f_id ?? 'novo_' + row.index}`"
                                :checked="false"
                                @click.prevent="removeParticipanteNaoPersistido(row.item)">
                            <label
                                class="custom-control-label"
                                :for="`switch_excluirParticipante_${row.item.f_id ?? 'novo_' + row.index}`">
                              Excluir participante
                            </label>
                          </div>
                        </template>
                      </default-table>
                      <div class="col-md-12">
                        <pagination
                          :class="{ 'invisivel': !estaEditandoEvento }"
                          :fonteDeDados="fonteDeDadosParticipantes"
                          :disabled="desabilitaNavegacaoParticipantes"
                          @navegarNaPaginacao="navegarNaPaginacaoParticipantes"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center col-12">
                    <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                    <b-spinner class="ml-2" variant="danger"></b-spinner>
                  </div>
                </div>
              </form>
            </div> <!-- card-body ends -->
            <div class="card-footer text-right">
              <div class="row btn-group btn-group-justified" role="group">
                <div v-show="ehProprietarioDoEvento" class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="desabilitaCampo" @click="salvarRegistro()">Salvar</b-button></div>
                <div v-show="exibirBotaoExcluir && ehProprietarioDoEvento" class="mr-1"><b-button class="botoes " variant="outline-danger btn-sm mt-2" @click="excluirRegistro()" :disabled="desabilitaBotaoExcluir">Excluir</b-button></div>
                <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="voltarRotaAnterior()">Cancelar</b-button>
              </div>
            </div>
            <b-modal id="modalConfirmacao" size="sm" cancel-title='Fechar' ok-title='Ok' @ok="executarConfirmacaoModal">
              <template #modal-title>
                <h6><span class="textos">{{tituloConfirmacaoModal}}</span></h6>
              </template>
              <form>
                <div class="form-check textos">
                  <label class="form-check-label mb-2">
                    <input type="radio" class="form-check-input" name="eventoRecorrente" :value=false v-model="formulario.afetarTodosEventos" checked>Este evento
                  </label>
                </div>
                <div class="form-check textos">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="eventoRecorrente" :value=true v-model="formulario.afetarTodosEventos">Todos os eventos
                  </label>
                </div>
              </form>
              <template v-slot:modal-footer="{ ok, cancel }">
                <b-button class="botoes" :variant="estiloBotaoConfirmacaoModal" @click="ok()">{{rotuloBotaoConfirmacaoModal}}</b-button>
                <b-button class="botoes" variant="outline-primary btn-sm" @click="cancel()">Cancelar</b-button>
              </template>
            </b-modal>
          </div> <!-- card ends -->
        </div>
      </div>
    </section>
  </div> <!-- /.content-wrapper -->

<div
    class="modal fade"
    id="modalExclusoes"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalExclusoesTitle"
    aria-describedby="modalExclusoesDesc"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">

        <div class="modal-header bg-light">
          <div>
            <h5 id="modalExclusoesTitle" class="modal-title font-weight-bold mb-1">
              <i class="fas fa-user-minus text-warning mr-2"></i>
              Revisão de exclusões
            </h5>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div id="modalExclusoesDesc" class="modal-body">

          <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
            <div>
              <span class="badge badge-danger badge-pill px-3 py-2" style="font-size: 0.95rem;">
                <i class="fas fa-users mr-1"></i>
                {{ participantesParaExcluir.length }}
                {{ participantesParaExcluir.length === 1 ? 'participante' : 'participantes' }}
                marcado{{ participantesParaExcluir.length === 1 ? '' : 's' }} para exclusão
              </span>
            </div>
            <button
              class="btn btn-sm btn-outline-secondary"
              @click="desmarcarTodosParticipantesParaExclusao"
              :disabled="desabilitaCampo || participantesParaExcluir.length === 0"
              v-if="participantesParaExcluir.length > 1"
            >
              <i class="fas fa-times-circle mr-1"></i>
              Limpar todos
            </button>
          </div>

          <default-table
            :items="participantesParaExcluir"
            :fields="fieldsParticipantes"
            :busy="desabilitaCampo"
            :tbody-tr-class="tabelaSemRegistros"
            :sort-by="componenteOrdenacao.campo"
            :sort-direction="componenteOrdenacao.sentido"
            :no-local-sorting="false"
            class="table-hover"
          >
            <template #empty>
              <div class="text-center py-5">
                <i class="fas fa-check-circle text-success mb-3" style="font-size: 3rem;"></i>
                <p class="text-muted mb-0">Nenhum participante marcado para exclusão.</p>
                <small class="text-muted">Você pode fechar este modal.</small>
              </div>
            </template>

            <template #cell(f_name)="row">
              <div class="d-flex align-items-center">
                <i class="fas fa-user-circle text-muted mr-2" style="font-size: 0.9rem;"></i>
                <div>
                  <div class="font-weight-medium">{{ row.item.f_name }}</div>
                  <div class="avisoDanger text-left mt-1" v-if="row.item.erros">
                    <i class="fas fa-exclamation-circle mr-1"></i>{{ row.item.erros }}
                  </div>
                </div>
              </div>
            </template>

            <template #cell(f_email)="row">
              <div class="d-flex align-items-center">
                <i class="fas fa-envelope text-muted mr-2" style="font-size: 0.85rem;"></i>
                <span class="text-muted">{{ row.item.f_email }}</span>
              </div>
            </template>

            <template #cell(opcoes)="row">
              <button
                class="btn btn-sm btn-outline-danger"
                title="Remover da lista de exclusão"
                @click="removerParticipanteDaListaDeExclusao(row.item)"
                :disabled="desabilitaCampo"
              >
                <i class="fas fa-undo mr-1" aria-hidden="true"></i>
                <span class="d-none d-md-inline">Manter</span>
                <span class="sr-only">Remover {{ row.item.f_name }} da lista de exclusões</span>
              </button>
            </template>
          </default-table>

        </div>

        <div class="modal-footer bg-light d-flex justify-content-between align-items-center" style="padding: 1rem 1.5rem;">
          <div class="text-muted small d-flex align-items-center">
            <i class="fas fa-lightbulb text-warning mr-2"></i>
            <span><strong>Lembre-se:</strong> As alterações só terão efeito ao salvar o formulário principal.</span>
          </div>
          <button
            type="button"
            class="btn btn-primary px-4"
            data-dismiss="modal"
          >
            <i class="fas fa-check mr-2"></i>
            Fechar
          </button>
        </div>

      </div>
    </div>
  </div>

</div> <!-- ./wrapper -->
</template>

<script>
import Cadastro from './js/cadastro-eventos'
export default Cadastro
</script>

<style scoped>
@import "./scss/eventos.scss";
</style>
